export enum FwdRollUpdateOperation {
  ADD,
  DELETE,
  UPDATE,
}

export namespace FwdRollUpdateOperation {
  let elements = [
    FwdRollUpdateOperation.ADD,
    FwdRollUpdateOperation.DELETE,
    FwdRollUpdateOperation.UPDATE,
  ];
  let alias = "com.bcdfx.model.fwdroll.FwdRollUpdateOperation";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
